module.exports = __webpack_public_path__ + "img/PT848.c15295af.png";